import { render, staticRenderFns } from "./clause.vue?vue&type=template&id=39d8c93b&scoped=true&"
import script from "./clause.vue?vue&type=script&lang=js&"
export * from "./clause.vue?vue&type=script&lang=js&"
import style0 from "./clause.vue?vue&type=style&index=0&id=39d8c93b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d8c93b",
  null
  
)

export default component.exports